import { FaCircle } from 'react-icons/fa'
import { IoMdClose } from 'react-icons/io'
import { Box, Button, Icon, Text } from '@chakra-ui/react'

import { Draggable } from './LineupEditModal/Draggable'
import { PlayerBasicInfo } from './PlayerBasicInfo'
import { getFakePlayerIndicator } from '@/utils/getFakePlayerIndicator'
import { getPrettyClass } from '@/utils/getPrettyClass'

interface PlayerProps {
    player: any
    variant?: 'dark' | 'light'
    isHomeTeam: boolean
    isSquadPlayer?: boolean
    isGoalKeeper?: boolean
    currentActivePlayer?: any
    onDeletePlayerClick?: (rowInd: number, colInd?: number) => void
    colInd?: number
    rowInd?: number
    index?: number
    isSubstitution?: boolean
    activeDroppable?: any
    droppableId?: string
    onPlayerClick?: (player) => void
    isShirtNumberTaken?: boolean
    placement: string
}

export function Player({
    player,
    isHomeTeam,
    isGoalKeeper,
    isSquadPlayer,
    currentActivePlayer,
    onDeletePlayerClick,
    variant,
    colInd,
    rowInd,
    index,
    isSubstitution,
    activeDroppable,
    droppableId,
    onPlayerClick,
    isShirtNumberTaken,
    placement,
}: PlayerProps) {
    const isCurrentActivePlayer = currentActivePlayer?.id === player.id || currentActivePlayer?.name === player.name
    const isPlayerActiveDroppable = activeDroppable?.id === droppableId && !isCurrentActivePlayer
    const shouldHideDeleteButton = isCurrentActivePlayer || isSquadPlayer || isPlayerActiveDroppable
    const isCaptain = player.captain

    const handleDeletePlayerClick = () => {
        if (onDeletePlayerClick) {
            if (isSubstitution && index !== undefined) {
                onDeletePlayerClick(index)
            }

            if (rowInd !== undefined && colInd !== undefined) {
                onDeletePlayerClick(rowInd, colInd)
            }
        }
    }

    const playerPosition = isSubstitution ? { index } : { colInd, rowInd }

    const handlePlayerClick = () => {
        if (onPlayerClick) {
            if (isSubstitution || isSquadPlayer) {
                onPlayerClick({ player, position: { index } })
            } else {
                onPlayerClick({ player, position: { colIndex: colInd, rowIndex: rowInd } })
            }
        }
    }

    const fakePlayerIndicator = getFakePlayerIndicator(player.id)
    const opacity = (isPlayerActiveDroppable && !isSquadPlayer) || isCurrentActivePlayer ? 0.4 : 1

    return (
        <Box
            position="relative"
            opacity={opacity}
            transition="opacity 0.5s"
            className={getPrettyClass(
                `${placement}-player-${player.name?.replace(' ', '-')}-${index ?? `${colInd}-${rowInd}`}`,
            )}>
            <Draggable
                player={player}
                position={playerPosition}
                isSubstitution={Boolean(isSubstitution)}
                placement={placement}>
                <PlayerBasicInfo
                    player={player}
                    isHomeTeam={isHomeTeam}
                    isGoalKeeper={isGoalKeeper}
                    isCurrentActivePlayer={isCurrentActivePlayer}
                    handlePlayerClick={handlePlayerClick}
                    variant={variant}
                    isShirtNumberTaken={isShirtNumberTaken}
                />
            </Draggable>
            {isCaptain && (
                <Box
                    backgroundColor="mediumorchid"
                    position="absolute"
                    left={1}
                    top={-1}
                    px={1}
                    py={0.1}
                    borderRadius="full"
                    border="1px solid white">
                    <Text color="white" fontWeight="bold" fontSize={12}>
                        C
                    </Text>
                </Box>
            )}
            {!shouldHideDeleteButton && (
                <Button
                    onClick={() => handleDeletePlayerClick()}
                    size="xs"
                    position="absolute"
                    right={0}
                    top={-2}
                    p={0}
                    borderRadius="full"
                    variant="mirage">
                    <Icon as={IoMdClose} boxSize="0.8rem" color="sp.white" />
                </Button>
            )}
            {fakePlayerIndicator?.show && (
                <Icon
                    as={FaCircle}
                    boxSize="0.6rem"
                    color={fakePlayerIndicator.color}
                    position="absolute"
                    left={2}
                    bottom={9}
                    p={0}
                />
            )}
        </Box>
    )
}
